import { getServiceURL } from "api/utils"
import { SERVICE_PREFIX } from "utils/constants"

const getErisURL = getServiceURL(SERVICE_PREFIX.eris)

export const urls = {
  growthspace: {
    list: () => "/v1/users/organizations/",
    createTransaction: () => getErisURL("/v1/licensing/users/transactions/"),
  },
}
